import CryptoBadgeAPI, { CryptoBadgeClient } from "@/api/cryptobadge";
import { H8Bold } from "@moim/common";
import {
  getCertificates_certificates_edges,
  getCertificates_certificates_edges_node,
} from "@vingle/cryptobadge-sdk";
import * as React from "react";
import { FormattedMessage } from "react-intl";
import {
  Container,
  SectionTitleWrapper,
  SectionTitle,
  RightArrow,
  RetryIcon,
} from "./styled";
import CardCryptoBadges from "./templates/card";
import CryptoBadges from "./templates/normal";

type CertificationEdges = getCertificates_certificates_edges & {
  node: getCertificates_certificates_edges_node & { issuerId: string };
};
interface IProps {
  viewType: "card" | "normal" | undefined;
  user: Moim.User.INormalizedUser;
  issuers?: Moim.Id[];
}

const CryptoBadgesContainer: React.FC<IProps> = ({
  viewType = "normal",
  user,
  issuers,
}) => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [cryptoBadges, setCryptoBadges] = React.useState<
    CertificationEdges[] | undefined
  >();

  const hasBadges = cryptoBadges?.length > 0;
  const userId = user.id;

  const handleNextButtonClick = React.useCallback(() => {}, []);

  const getCertifications = React.useCallback(
    async (
      userId: Moim.Id,
      params: {
        canId: string;
        issuers?: Moim.Id[];
      },
    ) => {
      setIsLoading(true);
      let cryptoBadgeIssuerIds;
      const currentGroupIssuers = ["G0PZG1KTR7"];

      if (params.issuers) {
        cryptoBadgeIssuerIds = params.issuers;
      } else if (currentGroupIssuers) {
        cryptoBadgeIssuerIds = currentGroupIssuers;
      }

      if (cryptoBadgeIssuerIds) {
        try {
          /**
           * NOTE: 2023.10.5. GraphQL을 수정하기엔 백엔드쪽 사이드이펙트 감당이 힘들어서 클라단에서 입력 받은 issuers로 분리 호출후 issuerId라는 필드를 주입해서 redux store에 저장시키도록 했습니다.
           */
          const result = await Promise.allSettled<CertificationEdges[][]>(
            cryptoBadgeIssuerIds.map(async issuerId => {
              const result =
                await CryptoBadgeAPI.getUserCryptoBadgeCertificates({
                  userId: params.canId,
                  issuer: issuerId,
                });
              return (
                result.certificates?.edges?.map<CertificationEdges>(edge => ({
                  ...edge,
                  node: {
                    ...edge.node,
                    issuerId,
                  },
                })) ?? []
              );
            }),
          );

          setCryptoBadges(
            result
              .map<CertificationEdges[]>(certifications => {
                if (certifications.status === "fulfilled") {
                  return certifications.value;
                }

                return [];
              })
              .flat(),
          );
        } catch (err) {}
      } else {
        // eslint-disable-next-line no-console
        console.log("!!!error: no cryptoBadgeIssuerIds");
      }

      setIsLoading(false);
    },
    [],
  );
  const handleClickRefreshButton: React.MouseEventHandler<HTMLSpanElement> =
    React.useCallback(
      async e => {
        e.stopPropagation();

        if (user.canId && !isLoading) {
          await CryptoBadgeClient.queryClient.clearStore();
          getCertifications(user.id, { canId: user.canId, issuers });
        }
      },
      [user.canId, user.id, isLoading, getCertifications, issuers],
    );
  React.useEffect(() => {
    if (user.canId && !isLoading) {
      getCertifications(user.id, { canId: user.canId, issuers });
    }
  }, [user?.canId]);

  return (
    <>
      <SectionTitleWrapper role="button" onClick={handleNextButtonClick}>
        <SectionTitle>
          <H8Bold>
            <FormattedMessage id="profile_show/badge_title" />
          </H8Bold>
          <RetryIcon onClick={handleClickRefreshButton} />
        </SectionTitle>
        {hasBadges && <RightArrow />}
      </SectionTitleWrapper>
      <Container>
        {viewType === "card" ? (
          <CardCryptoBadges
            columnCount={2}
            rowCount={2}
            isLoading={isLoading}
            cryptoBadges={{ data: cryptoBadges ?? [] }}
          />
        ) : (
          <CryptoBadges
            userId={userId}
            isLoading={isLoading}
            cryptoBadges={{ data: cryptoBadges ?? [] }}
          />
        )}
      </Container>
    </>
  );
};

export default CryptoBadgesContainer;
